import { render } from "./HeroiconsSolidLightningBolt.vue?vue&type=template&id=3f2c8450"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLightningBolt.vue"]])

export default __exports__